export default __webpack_public_path__ + "static/media/closet3-1440w.0b3f539d.webp";